import "./NewsSlider.css";
import NewsBig from "./NewsBig";
import NewsSmall from "./NewsSmall";
import "@splidejs/splide/dist/css/splide.min.css";
import useFetch from "../../hooks/useFetch";
import config from "../../config";

const NewsSlider = () => {
  // fetch dat omezeny na sudy pocet x nejnovejsich
  const { loading, error, data } = useFetch(
    `${config.api}/api/news?populate[0]=image&sort[1]=date:desc&pagination[page]=1&pagination[pageSize]=3`
  );
  if (loading) return <p className="container">Načítání aktualit...</p>;
  if (error) return <p className="container">Error při načítání aktualit</p>;

  //? test
  //? console.log('Aktuality',data);

  const recentNews = data.data;
  const smallNews = [];
  if (recentNews.length >= 2) {
    smallNews.push(recentNews[1], recentNews[2]);
  }
  return (
    <div className="d-flex align-items-center">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 col-12 news-big-background">
            <NewsBig
              id={recentNews[0].documentId}
              title={recentNews[0].name}
              alt={recentNews[0].image.alternativeText}
              image={`${config.api}${recentNews[0].image.url}`}
              date={recentNews[0].date}
              overview={recentNews[0].overview}
            />
          </div>
          <div className="col-lg-4 col-12 mt-2 mt-lg-0">
            <NewsSmall news={smallNews} />
          </div>
        </div>
      </div>
    </div>
  );
};
export default NewsSlider;
